import { Box, Typography, FormControl, Stack } from '@mui/material';
import { StringColorProps } from 'types/password';

interface PasswordStrengthMeterProps {
  level: StringColorProps | undefined;
}

const PasswordStrengthMeter = ({ level }: PasswordStrengthMeterProps) => {
  if (!level) return null;

  const getActiveSegments = (label: string = 'Poor') => {
    switch (label) {
      case 'Commonly used password':
      case 'Poor':
        return 1;
      case 'Weak':
        return 2;
      case 'Normal':
        return 3;
      case 'Good':
        return 4;
      case 'Strong':
        return 5;
      default:
        return 1;
    }
  };

  const activeSegments = getActiveSegments(level?.label);

  return (
    <FormControl fullWidth sx={{ mt: 2 }}>
      <Stack spacing={1}>
        <Box sx={{ display: 'flex', gap: 1, height: '6px', width: '50%' }}>
          {[1, 2, 3, 4, 5].map((segment) => (
            <Box
              key={segment}
              sx={{
                flex: 1,
                bgcolor: segment <= activeSegments ? level?.color : 'grey.300',
                borderRadius: '4px',
                transition: 'background-color 0.3s ease'
              }}
            />
          ))}
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'flex-start', mt: 0.5 }}>
          <Typography variant="subtitle1" fontSize="0.75rem">
            {level?.label}
          </Typography>
        </Box>
      </Stack>
    </FormControl>
  );
};

export default PasswordStrengthMeter;
